import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import _ from 'lodash'
import Diplomas from '@app/components/teachers/Diplomas'
import Loader from '@app/components/ui/placeholders/Loader'
import * as teacherActions from '@app/actions/teachers'
import { sortedClasses } from '@app/helpers/classesHelper'

class DiplomasContainer extends Component {
  componentDidMount() {
    this.updateIfNeeded()
  }

  async updateIfNeeded() {
    await this.props.boundActions.fetchClassesIfNeeded()
    if (!this.group) { return }

    const { global: { event: { id } } } = this.props
    this.props.boundActions.fetchDiplomasIfNeeded(this.group.object.id, id)
  }

  componentDidUpdate(prevProps) {
    if (prevProps.route != this.props.route) {
      this.updateIfNeeded()
    }
  }

  get group() {
    const { classes: { objects } } = this.props
    const { route: { match: { params: { id } } } } = this.props

    var group = objects[id]
    if (!group) { group = _.first(_.values(objects)) }

    return group
  }

  render() {
    const { classes: { fetching }, global: { event: { id } } } = this.props

    if (!this.group && fetching) { return <Loader /> }
    if (!this.group) { return null }

    const { route, classes: { objects } } = this.props
    return (
      <Diplomas
        classes={sortedClasses(objects)}
        event_id={id}
        group={this.group}
        route={route}
      />
    )
  }
}

const mapStateToProps = (state) => {
  const { teachers: { classes } } = state;
  return { classes }
}

const mapDispatchToProps = (dispatch) => {
  const boundActions = bindActionCreators(teacherActions, dispatch)
  return { boundActions }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  null, {
    getDisplayName: () => 'Diplomas'
  }
)(DiplomasContainer)
